import { z } from 'zod'

export enum EditorRole {
  Employee = 'employee',
  Employer = 'employer',
  Operator = 'operator',
  Admin = 'admin',
  System = 'system',
  TaxAdvisor = 'tax_advisor',
  App = 'app',
}

export const EditorRoleEnum = z.nativeEnum(EditorRole)
